enum BatteryStatus {

    FULL = 'FULL',
    HIGH = 'HIGH',
    MEDIUM = 'MEDIUM',
    LOW = 'LOW',
    CRITICAL = 'CRITICAL',
    CHARGING = 'CHARGING',
    UNKNOWN = 'UNKNOWN'
}

export default BatteryStatus;